import history from 'shared/util/routing/history'

/**
 * Always a push, so Back from the deal returns to the page that opened it. `skipDirtyPrompt` rides in
 * the location state, where the editors' route prompts read it. It used to `replace` as well, which
 * dropped the estimate from history: Create Deal → Back skipped past it to the estimate list
 * (ENG-2063).
 */
export function goToDeal(id: string, skipDirtyPrompt?: boolean, state?: Record<string, any>) {
  return history.push(`/deals/edit/${encodeURIComponent(id)}`, {
    ...(skipDirtyPrompt ? { skipDirtyPrompt: true } : {}),
    ...state
  })
}
